import { render } from "./PointsSettings.vue?vue&type=template&id=8381d0ee&scoped=true"
import script from "./PointsSettings.vue?vue&type=script&lang=js"
export * from "./PointsSettings.vue?vue&type=script&lang=js"

import "./PointsSettings.vue?vue&type=style&index=0&id=8381d0ee&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8381d0ee"]])

export default __exports__